import { Component, input, InputSignal } from '@angular/core';

import { ICalendarWeekViewEvent } from '../../interfaces/icalendar-week-view-event.interface';

@Component({
	selector: 'lb-calendar-week-view-event',
	standalone: true,
	imports: [],
	templateUrl: './calendar-week-view-event.component.html',
	styleUrl: './calendar-week-view-event.component.scss'
})
export class CalendarWeekViewEventComponent {
	public event: InputSignal<ICalendarWeekViewEvent> = input.required<ICalendarWeekViewEvent>();
	public index: InputSignal<number> = input<number>(0);
}
